import { render, staticRenderFns } from "./StockPosition.vue?vue&type=template&id=4911faaa&"
import script from "./StockPosition.vue?vue&type=script&lang=js&"
export * from "./StockPosition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports